const changeNameStr = {
  toastr: 'Nombre cambiado',
  toastr1: 'nombre cambiado con éxito'
};

export default changeNameStr;
